<template>
    <el-dialog :title="title + '租户'" width="50%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-steps :active="step" align-center class="m_b1" v-if="method != 'view'">
            <el-step title="基本信息"></el-step>
            <el-step title="创建租户管理员"></el-step>
            <el-step title="设置租户套餐"></el-step>
            <el-step title="配置产品信息"></el-step>
        </el-steps>
        <el-form size="small" :model="form" ref="form" label-width="160px" :rules="dataRule" v-loading="loading"
                 :disabled="method==='view'" v-if="form.tenantTenantDTO">
            <div v-if="step == 0">
                <el-form-item label="租户名称：" prop="tenantTenantDTO.tenantName">
                    <el-input v-model.trim="form.tenantTenantDTO.tenantName" placeholder="请输入租户名称（限20字）" clearable
                              maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="开始时间：" prop="tenantTenantDTO.effectiveStartTime">
                    <el-date-picker
                            v-model="form.tenantTenantDTO.effectiveStartTime"
                            type="datetime"
                            style="width: 100%"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="不填写表示租户立即生效">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="过期时间：" prop="tenantTenantDTO.effectiveEndTime">
                    <el-date-picker
                            v-model="form.tenantTenantDTO.effectiveEndTime"
                            type="datetime"
                            style="width: 100%"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="不填写表示租户永久有效">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="租户状态：" prop="tenantTenantDTO.effectiveSate">
                    <el-radio-group v-model="form.tenantTenantDTO.effectiveSate">
                        <el-radio :key="item.value" :label="item.value" v-for="item in $dictUtils.getDictList('effectiveSate')">{{item.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div v-if="step == 1">
                <el-form-item label="账号：" prop="userTenantDTO.loginName">
                    <el-input v-model.trim="form.userTenantDTO.loginName" placeholder="请输入账号（限20字）" clearable
                              maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="userTenantDTO.password">
                    <el-input v-model="form.userTenantDTO.password" placeholder="请输入密码（8-20位包含大小写字母，数字，特殊符号例如@）"
                              :type="passwordShow ? 'password' : 'text'" prefix-icon="el-icon-lock" maxlength="20"
                              auto-complete="new-password">
                        <template slot="suffix">
                            <div v-show="passwordShow" @click="passwordShow = !passwordShow"
                                 class="iconfont icon-eye-close"></div>
                            <div v-show="!passwordShow" @click="passwordShow = !passwordShow"
                                 class="iconfont icon-browse"></div>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="userTenantDTO.password2">
                    <el-input v-model="form.userTenantDTO.password2" placeholder="请确认新密码（8-20位包含大小写字母，数字，特殊符号例如@）"
                              :type="passwordShow2 ? 'password' : 'text'" prefix-icon="el-icon-lock" maxlength="20"
                              auto-complete="new-password">
                        <template slot="suffix">
                            <div v-show="passwordShow2" @click="passwordShow2 = !passwordShow2"
                                 class="iconfont icon-eye-close"></div>
                            <div v-show="!passwordShow2" @click="passwordShow2 = !passwordShow2"
                                 class="iconfont icon-browse"></div>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="姓名：" prop="userTenantDTO.name">
                    <el-input v-model.trim="form.userTenantDTO.name" placeholder="请输入姓名（限20字）" clearable maxlength="20"
                              @input="clearFieldValidation('userTenantDTO.name')"></el-input>
                </el-form-item>
                <el-form-item label="手机：" prop="userTenantDTO.mobilePhone">
                    <el-input v-model.trim="form.userTenantDTO.mobilePhone" placeholder="请输入手机" clearable
                              maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="电话：" prop="userTenantDTO.telPhone">
                    <el-input v-model.trim="form.userTenantDTO.telPhone" placeholder="请输入电话（xxxx-xxxxxxx）" clearable
                              maxlength="13"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="userTenantDTO.email">
                    <el-input v-model.trim="form.userTenantDTO.email" placeholder="请输入邮箱（xxxxxxx@xxx.xxx）"
                              maxlength="30"></el-input>
                </el-form-item>
            </div>
            <div v-if="step == 2">
                <el-form-item label="租户管理员角色名：" prop="roleTenantDTO.name">
                    <el-input v-model.trim="form.roleTenantDTO.name" placeholder="请输入角色名（限20字）" clearable
                              maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="选择套餐：" prop="roleTenantDTO.type">
                    <div class="flex_l_c">
                        <el-radio-group class="flex_1" v-model="form.roleTenantDTO.type" @input="changeType()">
                            <el-radio label="0">租户套餐</el-radio>
                            <el-radio label="1">自定义套餐</el-radio>
                        </el-radio-group>
                        <el-select class="m_l1" style="width: 40% !important;" v-model="form.roleTenantDTO.setMealId"
                                   placeholder="请选择"
                                   v-show="form.roleTenantDTO.type == 0" @change="selSetMeal">
                            <el-option
                                    v-for="(item, index) in setMealOpt"
                                    :key="index"
                                    :label="item.setMealName"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <el-tree
                            :data="menuList"
                            :props="defaultProps"
                            node-key="id"
                            ref="menuListTree"
                            show-checkbox :class="{ 'tree-disabled': isTreeDisabled }">
                    </el-tree>
                </el-form-item>
            </div>
            <div v-show="step == 3">
                <el-form-item label="产品标题：" prop="tenantProductConfigurationInfo.productName">
                    <div class="flex_l_c">
                        <el-input v-model.trim="form.tenantProductConfigurationInfo.productName" placeholder="请输入产品标题（限20字）"
                                  clearable maxlength="20" class="m_r2"></el-input>
                        <el-button size="mini" type="primary" round @click="viewExample">示例</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="登录页logo：" prop="tenantProductConfigurationInfo.loginLogUrl">
                    <Upload v-if="visible && method != 'view'" v-show="!form.tenantProductConfigurationInfo.loginLogUrl" :uploadAskObj="loginLogUrlRequire" @getDataList="getLoginLogUrl">
                        <template v-slot:updateStyle>
                            <div class="uploadBox">
                                <div class="el-icon-plus"></div>
                            </div>
                        </template>
                    </Upload>
                    <div class="uploadImg" v-show="form.tenantProductConfigurationInfo.loginLogUrl">
                        <el-image class="uploadImg" :src="form.tenantProductConfigurationInfo.loginLogUrl" fit="cover"></el-image>
                        <el-link v-if="method != 'view'" class="el-icon-delete" type="danger" :underline="false" @click="delUrl('loginLogUrl')"></el-link>
                    </div>
                    <div class="fontSize12">支持{{loginLogUrlRequire.fileSize}}px、{{ loginLogUrlRequire.megaNum }}M以内、{{loginLogUrlRequire.fileType.join(' / ')}}格式的图片</div>
                </el-form-item>
                <el-form-item label="登录页背景图：" prop="tenantProductConfigurationInfo.loginBackgroundLogUrl">
                    <Upload v-if="visible && method != 'view'" v-show="!form.tenantProductConfigurationInfo.loginBackgroundLogUrl" :uploadAskObj="loginBackgroundLogUrlRequire"
                            @getDataList="getLoginBackgroundLogUrl">
                        <template v-slot:updateStyle>
                            <div class="uploadBox">
                                <div class="el-icon-plus"></div>
                            </div>
                        </template>
                    </Upload>
                    <div class="uploadImg" v-show="form.tenantProductConfigurationInfo.loginBackgroundLogUrl">
                        <el-image class="uploadImg" :src="form.tenantProductConfigurationInfo.loginBackgroundLogUrl" fit="cover"></el-image>
                        <el-link v-if="method != 'view'" class="el-icon-delete" type="danger" :underline="false" @click="delUrl('loginBackgroundLogUrl')"></el-link>
                    </div>
                    <div class="fontSize12">支持{{loginBackgroundLogUrlRequire.fileSize}}px、{{ loginBackgroundLogUrlRequire.megaNum }}M以内、{{loginBackgroundLogUrlRequire.fileType.join(' / ')}}格式的图片</div>
                </el-form-item>
                <el-form-item label="产品logo：" prop="tenantProductConfigurationInfo.productLogUrl">
                    <Upload v-if="visible && method != 'view'" v-show="!form.tenantProductConfigurationInfo.productLogUrl" :uploadAskObj="productLogUrlRequire" @getDataList="getProductLogUrl">
                        <template v-slot:updateStyle>
                            <div class="uploadBox">
                                <div class="el-icon-plus"></div>
                            </div>
                        </template>
                    </Upload>
                    <div class="uploadImg" v-show="form.tenantProductConfigurationInfo.productLogUrl">
                        <el-image class="uploadImg" :src="form.tenantProductConfigurationInfo.productLogUrl" fit="cover"></el-image>
                        <el-link v-if="method != 'view'" class="el-icon-delete" type="danger" :underline="false" @click="delUrl('productLogUrl')"></el-link>
                    </div>
                    <div class="fontSize12">支持{{productLogUrlRequire.fileSize}}px、{{ productLogUrlRequire.megaNum }}M以内、{{productLogUrlRequire.fileType.join(' / ')}}格式的图片</div>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="p_b1">
            <el-button size="small" type="primary" @click="prev()" v-if="step > 0">上一步</el-button>
            <el-button size="small" type="primary" :disabled="loading" @click="next()" v-if="step < 3">下一步</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-if="step == 3 && method != 'view'" v-noMoreClick>提交</el-button>
        </div>
        <Example ref="example"></Example>
    </el-dialog>
</template>

<script>
    import Upload from "@/components/Upload/Upload";
    import Example from "./example";

    export default {
        components: {Upload, Example},
        data() {
            let validateEffectiveStartTime = (rule, value, callback) => {
                let {effectiveEndTime} = this.form.tenantTenantDTO
                if (effectiveEndTime && new Date(value) >= new Date(effectiveEndTime)) {
                    callback(new Error('开始时间必须小于过期时间'));
                    return;
                }
                if (new Date(effectiveEndTime) >= new Date(value)) {
                    this.$refs['form'].clearValidate(['tenantTenantDTO.effectiveEndTime']);
                }
                callback();
            };
            let validateEffectiveEndTime = (rule, value, callback) => {
                let {effectiveStartTime} = this.form.tenantTenantDTO
                if (effectiveStartTime && new Date(value) <= new Date(effectiveStartTime)) {
                    callback(new Error('过期时间必须大于开始时间'));
                    return;
                }
                if (new Date(effectiveStartTime) <= new Date(value)) {
                    this.$refs['form'].clearValidate(['tenantTenantDTO.effectiveStartTime']);
                }
                callback();
            };
            let validatePassword2 = (rule, value, callback) => {
                if (value && value !== this.form.userTenantDTO.password) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            }
            return {
                id: '',
                visible: false,
                loading: false,
                step: 0,
                title: '',
                method: '',
                setMealOpt: [],
                form: {},
                passwordShow: true,
                passwordShow2: true,
                defaultProps: {
                    label: 'name',
                    children: 'children',
                },
                menuList: [],
                dataRule: {
                    'tenantTenantDTO.tenantName': [
                        {required: true, message: '租户名称不能为空', trigger: 'blur'}
                    ],
                    'tenantTenantDTO.effectiveStartTime': [
                        {validator: validateEffectiveStartTime, trigger: 'change'}
                    ],
                    'tenantTenantDTO.effectiveEndTime': [
                        {validator: validateEffectiveEndTime, trigger: 'change'}
                    ],
                    'userTenantDTO.loginName': [
                        {required: true, message: '账号不能为空', trigger: 'blur'}
                    ],
                    'userTenantDTO.password': [
                        {required: true, message: '密码不能为空', trigger: 'blur'},
                        {validator: this.validator.isPwd, trigger: 'blur'}
                    ],
                    'userTenantDTO.password2': [
                        {required: true, message: '确认密码不能为空', trigger: 'blur'},
                        {validator: validatePassword2, trigger: 'blur'}
                    ],
                    'userTenantDTO.name': [
                        {required: true, message: '姓名不能为空', trigger: 'input'}
                    ],
                    'userTenantDTO.mobilePhone': [
                        {required: true, message: '手机不能为空', trigger: 'blur'},
                        {validator: this.validator.isMobile, trigger: 'blur'}
                    ],
                    'userTenantDTO.telPhone': [
                        {validator: this.validator.isPhone, trigger: 'blur'}
                    ],
                    'userTenantDTO.email': [
                        {validator: this.validator.isEmail, trigger: 'blur'}
                    ],
                    'roleTenantDTO.name': [
                        {required: true, message: '角色名不能为空', trigger: 'blur'}
                    ],
                },
                loginLogUrlRequire: {
                    list: [],
                    count: 1, // 上传文件数量 0表示不限制文件的数量
                    fileType: ['gif', 'jpg', 'jpeg', 'png', 'bmp'],
                    megaNum: 10,
                    showFile: false,
                    customUploadStyle: true,
                    fileSize: '234*234',
                    pictureSize: true, //是否开启验证图片尺寸
                },
                loginBackgroundLogUrlRequire: {
                    list: [],
                    count: 1, // 上传文件数量 0表示不限制文件的数量
                    fileType: ['gif', 'jpg', 'jpeg', 'png', 'bmp'],
                    megaNum: 10,
                    showFile: false,
                    customUploadStyle: true,
                    fileSize: '1920*1080',
                    pictureSize: true, //是否开启验证图片尺寸
                },
                productLogUrlRequire: {
                    list: [],
                    count: 1, // 上传文件数量 0表示不限制文件的数量
                    fileType: ['gif', 'jpg', 'jpeg', 'png', 'bmp'],
                    megaNum: 10,
                    showFile: false,
                    customUploadStyle: true,
                    fileSize: '68*68',
                    pictureSize: true, //是否开启验证图片尺寸
                },
                isTreeDisabled: true,
            }
        },
        methods: {
            init(row, method) {
                this.resetFormData()
                this.getSetMeal()
                this.step = 0
                this.loading = false
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.visible = true
                this.$nextTick(() => {
                    if (row) {
                        this.id = row.id
                        this.dataRule['userTenantDTO.password'][0].required = false
                        this.dataRule['userTenantDTO.password2'][0].required = false
                        this.getInfo()
                    } else {
                        this.dataRule['userTenantDTO.password'][0].required = true
                        this.dataRule['userTenantDTO.password2'][0].required = true
                    }
                })
            },
            // 获取详情信息
            getInfo() {
                this.loading = true
                this.$axios(this.api.user.systemporaryauthorityGetById + '/' + this.id).then(data => {
                    if (data.status) {
                        this.form = this.recover(this.form, data.data)
                        if (this.form.roleTenantDTO.setMealId) {
                            this.$set(this.form.roleTenantDTO, 'type', '0')
                            this.isTreeDisabled = true
                        } else {
                            this.$set(this.form.roleTenantDTO, 'type', '1')
                            this.isTreeDisabled = false
                        }
                    } else {
                        this.$message.error('查询失败')
                    }
                    this.loading = false
                })
            },
            // 获取套餐
            getSetMeal() {
                this.$axios(this.api.user.selectAll, {}, 'post').then(data => {
                    if (data.status) {
                        this.setMealOpt = data.data
                        if(this.method != 'add') {
                            this.form = this.recover(this.form, this.form)
                        }
                    }
                })
            },
            // 获取所有菜单
            getMenu() {
                this.loading = true
                this.$axios(this.api.user.findAllMenu, {}, 'get').then(data => {
                    if (data.status) {
                        this.menuList = data.data
                        this.$nextTick(() => {
                            this.changeType(this.method != 'add' ? 1 : '')
                        })
                    }
                    this.loading = false
                })
            },
            // 选择套餐类型  flag=1数据渲染
            changeType(flag) {
                this.$refs.menuListTree.setCheckedKeys([])
                let {type} = this.form.roleTenantDTO
                this.isTreeDisabled = type === '0' // 租户套餐时禁用
                if(flag == 1) {
                    this.setMenuIds()
                } else {
                    if (type == 1 || !this.setMealOpt.length) {
                        this.form.roleTenantDTO.setMealId = ''
                        this.form.roleTenantDTO.menuIds = ''
                    } else {
                        this.form.roleTenantDTO.setMealId = this.setMealOpt[0].id
                        this.form.roleTenantDTO.menuIds = this.setMealOpt[0].menuIds
                        this.$nextTick(() =>  {
                            this.setMenuIds()
                        })
                    }
                }

            },
            // 选择套餐
            selSetMeal(val) {
                let opt = this.setMealOpt.filter(v => v.id == val)[0]
                this.form.roleTenantDTO.menuIds = opt.menuIds
                this.$nextTick(() =>  {
                    this.setMenuIds()
                })
            },
            // 设置菜单id
            setMenuIds() {
                let {menuIds} = this.form.roleTenantDTO
                if(!menuIds) {
                    return
                }
                this.$refs.menuListTree.setCheckedKeys([])
                this.$nextTick(() =>  {
                    let ids = menuIds.split(',')
                    ids.forEach(value => {
                        this.$refs.menuListTree.setChecked(value, true, false)
                    })
                })
            },
            // 校验手机号是否存在
            getPhoneIsExist() {
                this.$axios(this.api.user.phoneIsExist, {phone: this.form.userTenantDTO.mobilePhone, id: this.form.userTenantDTO.id}).then(data => {
                    if (data.status) {
                        this.step++
                        this.getMenu()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 校验账号是否存在
            getLoginNameIsExist() {
                this.$axios(this.api.user.loginNameIsExist, {loginName: this.form.userTenantDTO.loginName, id: this.form.userTenantDTO.id}).then(data => {
                    if (data.status) {
                        this.getPhoneIsExist()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 清除指定字段的验证状态
            clearFieldValidation(prop) {
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate([prop]);
                    }
                });
            },
            getLoginLogUrl(data) {
                this.form.tenantProductConfigurationInfo.loginLogUrl = data.response.data
            },
            getLoginBackgroundLogUrl(data) {
                this.form.tenantProductConfigurationInfo.loginBackgroundLogUrl = data.response.data
            },
            getProductLogUrl(data) {
                this.form.tenantProductConfigurationInfo.productLogUrl = data.response.data
            },
            // 下一步
            next() {
                if(this.method == 'view') {
                    this.step++
                    if(this.step == 2) {
                        this.getMenu()
                    }
                } else {
                    if (this.step == 2) {
                        let menuIds = this.$refs.menuListTree.getCheckedKeys().concat(this.$refs.menuListTree.getHalfCheckedKeys()).join(',')
                        if (!menuIds) {
                            this.$message.warning('请选择菜单')
                            return
                        }
                        this.form.roleTenantDTO.menuIds = menuIds
                    }
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            if (this.step == 1) {
                                this.getLoginNameIsExist()
                            } else {
                                this.step++
                            }
                        }
                    })
                }
            },
            // 上一步
            prev() {
                this.$refs.form.clearValidate()
                this.step--
                if (this.step == 2) {
                    this.$nextTick(() => {
                        this.setMenuIds()
                    })
                }
            },
            delUrl(type) {
                this.$confirm(`确定删除吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.tenantProductConfigurationInfo[type] = ''
                    if(type == 'loginLogUrl') {
                        this.loginLogUrlRequire.list = []
                    } else if(type == 'loginBackgroundLogUrl') {
                        this.loginBackgroundLogUrlRequire.list = []
                    } else if(type == 'productLogUrl') {
                        this.productLogUrlRequire.list = []
                    }
                    this.$message.success('删除成功')
                })
            },
            // 确定
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let api = this.api.user.systemporaryauthoritySave, type = 'post'
                        if (this.method == 'edit') {
                            api = this.api.user.systemporaryauthorityUpdateById
                            type = 'put'
                        }
                        this.$axios(api, this.form, type).then(data => {
                            if (data.status) {
                                this.$message.success('操作成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
            // 示例
            viewExample() {
                this.$refs.example.init()
            },
            resetFormData() {
                // 重置表单数据到初始状态
                this.form = {
                    tenantTenantDTO: {
                        id: '',
                        tenantName: '',
                        effectiveStartTime: '',
                        effectiveEndTime: '',
                        effectiveSate: '1',
                    },
                    userTenantDTO: {
                        id: '',
                        loginName: '',
                        password: '',
                        password2: '',
                        name: '',
                        mobilePhone: '',
                        telPhone: '',
                        email: '',
                    },
                    roleTenantDTO: {
                        id: '',
                        name: '',
                        type: '0',
                        setMealId: '',
                        menuIds: '',
                    },
                    tenantProductConfigurationInfo: {
                        productName: '',
                        loginLogUrl: '',
                        loginBackgroundLogUrl: '',
                        productLogUrl: '',
                    }
                };

                // 清除表单验证状态
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .uploadBox {
        width: 100px;
        text-align: center;
        height: 100px;
        line-height: 100px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
    }

    .uploadImg {
        width: 100px;
        height: 100px;
        border-radius: 6px;
        position: relative;
        overflow: hidden;

        .el-icon-delete {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            line-height: 100%;
            background: rgba(0,0,0,0.2);
            text-align: center;
            font-size: 14px;
            display: none;
        }
    }

    .uploadImg:hover {
        .el-icon-delete {
            display: inline-flex;
        }
    }

    .tree-disabled {
        pointer-events: none;
        opacity: 0.6; // 可选：视觉上提示禁用状态
    }
</style>
